import React from "react";
import { translate } from "Shared/translate";
import Button from "Shared/Button";
import LoginContainer from "Shared/Login/Container";
import * as styles from "./base.scss";
const ProductLoginToBuy = () => (React.createElement(LoginContainer, null, ({ setLoginUrl }) => (React.createElement(Button, { className: styles.btn, onClick: setLoginUrl },
    React.createElement("span", { className: styles.text }, translate("/Account/Login/LoginToBuy")),
    " "))));
export default ProductLoginToBuy;
